// Heartbeat.js
'use strict';
import { css, keyframes } from 'styled-components';

export const HeartbeatKeyframes = ({ ratio = 1.05 } = {}) => keyframes`
  80% { transform: scale(1); }
  90% { transform: scale(${ratio}); }
  100% { transform: scale(1); }
`;

export const Heartbeat = ({ ratio } = {}) => css`
  ${HeartbeatKeyframes({ ratio })}
`;

export default Heartbeat;
